export const swiperOnInitChoose = (tabsList, tabsWrap) => {
    tabsList.slides.forEach((s, i) => {
        if ('#'+s.getAttribute('anchor') == location.hash || s.getAttribute('href') == location.hash || s.classList.contains('prechoosed')) 
            tabsWrap.slideTo(i, 400);
    });
};